import Vue from 'vue'

/**
 * Format JPY
 */
Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
    return value
  }
  if (value <= 0) {
    return '無料'
  }
  var formatter = new Intl.NumberFormat('ja-JP', {
    style: 'currency',
    currency: 'JPY',
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});

/**
 * Format Date
 */
let moment = require('moment-timezone')

Vue.filter('toDate', function (value) {
  if (value) {
    return moment(String(value)).format('YYYY年MM月DD日')
  } else {
    return null;
  }
});

/**
 * Format SimpleDate
 */
Vue.filter('toSimpleDate', function (value) {
  if (value) {
    let date = moment(String(value))
    if ( date.format('YYYY') == moment().format('YYYY') ) {
      return date.format('MM月DD日')
    } else {
      return date.format('YYYY年MM月DD日')
    }
  } else {
    return null;
  }
});

/**
 * Format DateTime
 */
Vue.filter('toDateTime', function (value) {
  if (value) {
    return moment(String(value)).format('YYYY年MM月DD日 HH時mm分')
  } else {
    return null;
  }
});

/**
 * Format Time
 */
Vue.filter('toTime', function (value) {
  if (value) {
    return moment(String(value)).format('HH時mm分')
  } else {
    return null;
  }
});

/**
 * Format Twitter Time
 */
Vue.filter('toTwitterTime', function (value) {
  if (value) {
    return moment(String(value)).twitterShort()
  } else {
    return null;
  }
});

/**
 * Format to timezone Date Time
 */
Vue.filter('toTimeZoneDateTime', function (value) {
  if (value) {
    return moment(String(value)).tz('UTC').format('YYYYMMDD\THHmmss\\Z')
  } else {
    return null;
  }
});

/**
 * Format to size
 */
Vue.filter('toFileSize', function (value) {
  if ( value == 0 ) return '0 Bytes';
  var k = 1000,
    dm = 2,
    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(value) / Math.log(k));
  return parseFloat((value / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
});

/**
 * Truncate Text
 */

Vue.filter('truncate', function (value) {
	return value.substring(0, 30) + '...'
});


// WEBPACK FOOTER //
// ./resources/js/plugins/filters.js